<template>
  <div class="input">
    <div class="input-label">口座番号</div>
    <div class="input-group">
      <input type="text" class="input-text" v-model="accountNumber">
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    accountNumber: {
      get: function () {
        return this.$store.state.bank.accountNumber
      },
      set: function (value) {
        this.$store.commit(
          'bank/setAccountNumber',
          value
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_form.scss'
</style>
